module.exports = __webpack_public_path__ + "img/Gijon.0aa55c83.jpg";